import type { TInvalidRecords } from '../Step2/hooks/useDataValidation/types';

export const getUniqueNestedEmails = (allErrors?: TInvalidRecords[]) => {
  const uniqueEmails = new Set<string>();
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!allErrors) return [];
  allErrors.forEach(error => {
    const subErrors = error.subErrors || [];
    subErrors.forEach(subError => {
      const errors = subError?.errors || [];
      errors.forEach(error => {
        if (error?.email) {
          uniqueEmails.add(error.email);
        }
      });
    });
  });
  return Array.from(uniqueEmails);
};
